import React from 'react';
import ServiceEditor from './ServiceEditor';

const MAX_SERVICES = 6;

const Step3Services = ({ data, onChange }) => {
    const services = data.services || [];

    const handleAdd = () => {
        if (services.length >= MAX_SERVICES) return;
        const newService = { icon: '🎯', title: '', description: '' };
        onChange('services', [...services, newService]);
    };

    const handleUpdate = (index, field, value) => {
        const updated = services.map((s, i) =>
            i === index ? { ...s, [field]: value } : s
        );
        onChange('services', updated);
    };

    const handleDelete = (index) => {
        const updated = services.filter((_, i) => i !== index);
        onChange('services', updated);
    };

    return (
        <div>
            <h2 className="step-title">Your Services</h2>
            <p className="step-subtitle">
                Add the services your business offers (1–{MAX_SERVICES} services).
            </p>

            {services.length === 0 && (
                <div className="services-empty">
                    <span style={{ fontSize: '2rem' }}>🛠️</span>
                    <p>No services added yet. Click the button below to add your first service.</p>
                </div>
            )}

            {services.length > 0 && (
                <div className="services-list">
                    {services.map((service, index) => (
                        <ServiceEditor
                            key={index}
                            service={service}
                            index={index}
                            onUpdate={handleUpdate}
                            onDelete={handleDelete}
                        />
                    ))}
                </div>
            )}

            {services.length < MAX_SERVICES && (
                <button
                    type="button"
                    className="btn-accent"
                    onClick={handleAdd}
                >
                    + Add Service
                </button>
            )}

            {services.length >= MAX_SERVICES && (
                <p className="char-counter" style={{ textAlign: 'left' }}>
                    Maximum of {MAX_SERVICES} services reached.
                </p>
            )}
        </div>
    );
};

export default Step3Services;
